import _Table from "./Table.vue";
import _TableItem from "./TableItem.vue";
import _TableRow from "./TableRow.vue";
import _ImageItem from "./ImageItem.vue";

export const Table = _Table;
export const TableItem = _TableItem;
export const TableRow = _TableRow;
export const ImageItem = _ImageItem;
